/* Vehicle -> vehicle collection router for the YMM selector (Spoon Sports UK).
   The lookup is built by the theme (snippets/ymm-vehicle-map, rendered in <head>) from each vehicle metaobject's
   "Vehicle collection" field (Shopify admin > Content > Metaobjects > Vehicle) and exposed as
   window.ymmVehicleMap = { "<vehicle metaobject numeric id>": "<collection handle>" }.
   window.ymmUniversalId is the "Universal" vehicle entry, always added to in-place filters.
   Vehicles with no collection set fall back to filtering the current / make collection. */
(function () {
  var MAP = window.ymmVehicleMap || {};
  var UNIVERSAL_ID = String(window.ymmUniversalId || '');
  var FILTER_PARAM = 'filter.p.m.custom.associate_vehicle';
  var COOKIE = 'torque_mmy_metaobject';
  var handles = {};
  var byHandle = {};
  for (var k in MAP) {
    handles[MAP[k]] = true;
    if (!byHandle[MAP[k]]) byHandle[MAP[k]] = k;
  }

  function currentHandle() {
    var p = window.location.pathname;
    var i = p.indexOf('/collections/');
    if (i === -1) return '';
    return p.slice(i + 13).split('/')[0];
  }

  window.ymm = {
    map: MAP,
    filterLimit: 5000, // native Shopify filtering stops working above this many products
    filterParam: FILTER_PARAM,
    isVehicleCollectionHandle: function (h) { return !!handles[h]; },
    vehicleIdForHandle: function (h) { return byHandle[h] || null; },
    currentHandle: currentHandle,
    getCookie: function () {
      var m = document.cookie.match(new RegExp('(^| )' + COOKIE + '=([^;]+)'));
      return m ? decodeURIComponent(m[2]) : null;
    },
    setCookie: function (id) {
      document.cookie = COOKIE + '=' + encodeURIComponent(id) + '; path=/; max-age=31536000; SameSite=Lax';
    },
    clearCookie: function () {
      document.cookie = COOKIE + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    },
    /* opts: vehicleId, make, productCount (current collection, 0 if none), onVehicleCollection (bool), makes (lowercase array) */
    destination: function (opts) {
      var id = String(opts.vehicleId);
      var handle = currentHandle();
      var onCollection = handle !== '';
      var vehicleHandle = MAP[id];
      var isMake = onCollection && opts.makes && opts.makes.indexOf(handle) !== -1;
      var tooBig = (opts.productCount || 0) > this.filterLimit;
      var onVehicle = !!opts.onVehicleCollection || (onCollection && !!handles[handle]);
      if (vehicleHandle && (!onCollection || isMake || tooBig || onVehicle)) {
        return { mode: 'collection', url: window.location.origin + '/collections/' + vehicleHandle, same: vehicleHandle === handle };
      }
      var url = onCollection
        ? new URL(window.location.origin + window.location.pathname)
        : new URL(window.location.origin + '/collections/' + encodeURIComponent((opts.make || 'all').toLowerCase()));
      url.searchParams.append(FILTER_PARAM, 'gid://shopify/Metaobject/' + id);
      if (UNIVERSAL_ID) url.searchParams.append(FILTER_PARAM, 'gid://shopify/Metaobject/' + UNIVERSAL_ID);
      return { mode: 'filter', url: url.toString(), same: false };
    }
  };
})();
